var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image-viewer',{attrs:{"z-index":3000,"urlList":_vm.srcList,"on-close":_vm.closeViewer}})}
var staticRenderFns = []

export { render, staticRenderFns }